import { type AnyRoute, createRoute } from "@tanstack/react-router";
import { lazy } from "react";

// Lazily loaded — the video studio (composer, gallery, player lightbox) isn't
// needed on the default /chat landing, so it ships as its own chunk.
const VideosPage = lazy(() =>
  import("../components/VideosPage").then((m) => ({ default: m.VideosPage })),
);

/**
 * Videos route — composed into the app shell layout in `app/router.tsx`. The
 * studio renders its "Creations" header into the shell topbar (TopbarSlot
 * portals), so it mounts directly under the shared top row.
 */
export function createVideosRoute<TParent extends AnyRoute>(parent: TParent) {
  return createRoute({
    getParentRoute: () => parent,
    path: "/videos",
    component: VideosPage,
  });
}
